import { el, button } from './dom.js';
import type { BuildTool } from '../app/GameController.js';

export interface HudElements {
  root: HTMLElement;
  day: HTMLElement;
  week: HTMLElement;
  score: HTMLElement;
  speedBtns: HTMLButtonElement[];
  toolBtns: Record<BuildTool, HTMLButtonElement>;
  pauseBtn: HTMLButtonElement;
}

export function createGameHud(
  onPause: () => void,
  onSpeed: (s: 1 | 2 | 3) => void,
  onTool: (t: BuildTool) => void,
  onMenu: () => void,
): HudElements {
  const root = el('div', 'game-hud');
  const top = el('div', 'hud-top');
  const day = el('span', 'hud-stat', ['Jour 1']);
  const week = el('span', 'hud-stat', ['Semaine 1']);
  const score = el('span', 'hud-stat score', ['Score 0']);
  top.append(day, week, score, button('☰', 'btn icon hud-menu', onMenu));

  const bottom = el('div', 'hud-bottom');

  const tools = el('div', 'hud-tools');
  const cableBtn = button('Câble 0', 'btn tool active', () => onTool('cable'));
  const relayBtn = button('Relais 0', 'btn tool', () => onTool('relay'));
  const switchBtn = button('Switch 0', 'btn tool', () => onTool('switch'));
  const teleporterBtn = button('Portail 0', 'btn tool', () => onTool('teleporter'));
  const eraseBtn = button('Effacer', 'btn tool', () => onTool('erase'));
  tools.append(cableBtn, relayBtn, switchBtn, teleporterBtn, eraseBtn);

  const speeds = el('div', 'hud-speeds');
  const s1 = button('×1', 'btn speed active', () => onSpeed(1));
  const s2 = button('×2', 'btn speed', () => onSpeed(2));
  const s3 = button('×3', 'btn speed', () => onSpeed(3));
  speeds.append(s1, s2, s3);

  const pauseBtn = button('⏸', 'btn icon pause', onPause);

  bottom.append(tools, speeds, pauseBtn);
  root.append(top, bottom);

  return {
    root,
    day,
    week,
    score,
    speedBtns: [s1, s2, s3],
    toolBtns: {
      cable: cableBtn,
      relay: relayBtn,
      switch: switchBtn,
      teleporter: teleporterBtn,
      erase: eraseBtn,
    },
    pauseBtn,
  };
}

export function updateHud(
  hud: HudElements,
  data: {
    day: number;
    week: number;
    score: number;
    cables: number;
    relays: number;
    switches: number;
    teleporters: number;
    pendingTeleporter: boolean;
    paused: boolean;
    speed: number;
    tool: BuildTool;
  },
): void {
  hud.day.textContent = `Jour ${data.day}`;
  hud.week.textContent = `Semaine ${data.week}`;
  hud.score.textContent = `Score ${Math.floor(data.score)}`;
  hud.toolBtns.cable.textContent = `Câble ${data.cables}`;
  hud.toolBtns.relay.textContent = `Relais ${data.relays}`;
  hud.toolBtns.switch.textContent = `Switch ${data.switches}`;
  hud.toolBtns.teleporter.textContent = data.pendingTeleporter
    ? 'Portail B'
    : `Portail ${data.teleporters}`;
  hud.pauseBtn.textContent = data.paused ? '▶' : '⏸';
  hud.speedBtns.forEach((b, i) => b.classList.toggle('active', data.speed === i + 1));
  (Object.keys(hud.toolBtns) as BuildTool[]).forEach((t) => {
    hud.toolBtns[t].classList.toggle('active', data.tool === t);
  });
}
